/*
 * @Author: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @Date: 2025-04-23 12:01:29
 * @LastEditors: jiakaiwen jiakaiwen@huihaiyinhe.com
 * @LastEditTime: 2025-12-29 15:49:36
 */

/**
 * PhotoGallery 组件
 *
 * 功能：显示底部缩略图列表，用于快速浏览和切换照片
 * 特点：
 * - 高亮显示当前选中的照片
 * - 支持视频缩略图（带播放标识）
 * - 对比模式下添加"原图"标签
 * - 支持滚动加载更多
 */

import React from 'react'
import classnames from 'classnames'
import icon_play from '../../../../images/icon_play.png'
import { message } from 'antd'
import type { Photo, Photos } from '../types'

interface PhotoGalleryProps {
  photos: Photos
  activeIndex: number
  isFullScreen: boolean
  aiProcessing: boolean
  isComparisonMode: boolean
  onScroll: (e: React.UIEvent<HTMLDivElement>) => void
  onWheel: (e: React.WheelEvent) => void
  onSelectPhoto: (index: number) => void
}

const PhotoGallery: React.FC<PhotoGalleryProps> = ({
  photos,
  activeIndex,
  isFullScreen,
  aiProcessing,
  isComparisonMode,
  onScroll,
  onWheel,
  onSelectPhoto
}) => {
  // 处理选择照片的逻辑
  const handlePhotoClick = (index: number) => {
    // 如果当前照片的isLimitViewByPhotoCount是true，则不进行选择
    if (photos[index]?.isLimitViewByPhotoCount) {
      message.warning('团队存储已满，超限照片无法查看')
      return
    }
    onSelectPhoto(index)

    // 添加自动滚动到选中缩略图的逻辑
    setTimeout(() => {
      const photoFrames = document.getElementsByClassName('photo-frame')
      if (photoFrames && photoFrames[index]) {
        photoFrames[index].scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center'
        })
      }
    }, 0)
  }

  return (
    <div
      className="gallery"
      style={isFullScreen || aiProcessing ? { height: 0 } : {}}
      onScroll={onScroll}
      onWheel={onWheel}
    >
      <div className="gallery-center-container">
        <div className="gallery-wall">
          {photos.map((photo, index) => (
            <div
              key={index}
              className={classnames('photo-frame', {
                'photo-frame-active': index === activeIndex
              })}
              onClick={() => handlePhotoClick(index)}
              style={{ position: 'relative' }}
            >
              <img src={photo.smallURL} alt="" />
              {photo.mediaType === 1 && (
                <img className="playImage" src={icon_play} alt="" />
              )}
              {/* 在对比模式下，为原图添加"原图"标签 */}
              {isComparisonMode && index === 0 && (
                <div
                  style={{
                    position: 'absolute',
                    bottom: '3px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    color: 'white',
                    padding: '2px 5px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    fontWeight: 'bold'
                  }}
                >
                  原图
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default PhotoGallery
